import {
    ADMIN_DRAWER,
    DRAWER,
} from '../constants/index';




export function switchAdminView(data) {
    return {
        type: ADMIN_DRAWER,
        payload:{
            view: data.target.textContent
        },

    };
}
export function switchMenu(data) {
    return {
        type: DRAWER,
        payload:{
            openMenu: data
        },

    };
}


// WEBPACK FOOTER //
// ./src/actions/admin.js